export const getSurveyElements = state => state?.survey?.elements || []
export const getSurveyProgress = state => state?.survey?.progress